// authAPI.js
import { GMAIL_REGISTER, LOGIN, LOGOUT, REGISTER } from "../common/URLs";

const setUserCookie = (obj) => {
  // Store full response JSON so fetchCookie can parse user.user.user_type
  const cookieValue = JSON.stringify(obj);
  // Max-Age is in SECONDS
  document.cookie = `userToken=${encodeURIComponent(cookieValue)}; Path=/; Max-Age=${7 * 24 * 60 * 60}; `;
};

export const GoogleCreate = async (userData) => {
  console.log("userdata in api", userData);

  const response = await fetch(GMAIL_REGISTER, {
    method: "POST",
    body: JSON.stringify(userData),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    const errorData = JSON.parse(errorText);
    if (response.status === 422) {
      console.log("error field is", errorData.errors[0]);
    }
    throw new Error(`${errorData.errors[0]}`);
  }

  const responseBody = await response.json();
  console.log("responseBody (GoogleCreate): ", responseBody);

  // Set cookie with full JSON user data if present
  if (responseBody?.user?.user_type) {
    setUserCookie(responseBody);
  }

  return responseBody;
};

export const createUser = async (userData) => {
  const response = await fetch(REGISTER, {
    method: "POST",
    body: JSON.stringify(userData),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    const errorData = JSON.parse(errorText);
    if (response.status === 422) {
      console.log("error field is", errorData.errors[0]);
    }
    throw new Error(`${errorData.errors[0]}`);
  }

  const responseBody = await response.json();
  console.log("responseBody (createUser): ", responseBody);

  // IMPORTANT: Do NOT set cookie here. Some registration APIs don't return a full user object.
  // We'll auto-login right after signup to set a proper cookie.

  return responseBody;
};

export const loginUser = async (userData) => {
  try {
    const response = await fetch(LOGIN, {
      method: "POST",
      body: JSON.stringify(userData),
      headers: {
        "content-type": "application/json",
      },
    });

    if (!response.ok) {
      if (response.status === 401) {
        // Invalid email or password
      }
      const errorText = await response.text();
      const errorData = JSON.parse(errorText || "{}");
      throw new Error(errorData?.error?.[0] || "Login failed");
    }

    const data = await response.json();
    console.log("responseBody (loginUser): ", data);

    // Set cookie with the full response object
    if (data?.user?.user_type) {
      setUserCookie(data);
    }

    return data;
  } catch (error) {
    console.log("error: ", error);
    throw error;
  }
};

export const logout = async (accessToken) => {
  try {
    const response = await fetch(LOGOUT, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
        Accept: "application/json",
      },
    });
    const data = await response.json();
    console.log("response: ", data);

    return data;
  } catch (error) {
    console.error("error ", error);
    return error;
  }
};